import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Accordion,
  Card,
  Modal,
  Spinner,
  Badge,
} from "react-bootstrap";
import {
  FaRocket,
  FaBox,
  FaCouch,
  FaCar,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaClock,
  FaChevronDown,
  FaChevronUp,
  FaTimes,
  FaPaperPlane,
  FaRoad,
  FaWeightHanging,
  FaEuroSign,
  FaRoute,
  FaLongArrowAltRight,
} from "react-icons/fa";
import {
  MapContainer,
  TileLayer,
  Polyline,
  Marker,
  Popup,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { driverAPI, postalAreaAPI } from "../../../api/apiSystem";
import "../PageOne/DarkTheme.css";
import NavbarMenu from "../../heroSection/NavbarMenu";
import Footer from "../../footer/Footer";
import PaginationComponent from "../../PaginationComponent";
import DriverChatModal from "../DriverChatModal";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { RouteMap } from "../../RouteMap";
import { formatNumber } from "../../../utils/helpers";
import BookingDetailsPage from "./BookingDetailsPage";
import TransportDetailsPage from "./TransportDetailsPage";
import { formatDisplayDate } from "../../../utils/helpers";
import paletteImg from "../../../assets/images/driver_transport_icon/palette.png";
import paketeImg from "../../../assets/images/driver_transport_icon/pakete.png";
import documentImg from "../../../assets/images/driver_transport_icon/document.png";
import furnitureImg from "../../../assets/images/driver_transport_icon/furniture.png";
import electricalImg from "../../../assets/images/driver_transport_icon/electrical.png";
import tiresImg from "../../../assets/images/driver_transport_icon/tires.png";
import refrigeratorImg from "../../../assets/images/driver_transport_icon/refrigerator.png";
import buildingMaterialsImg from "../../../assets/images/driver_transport_icon/building_materials.png";
import movingImg from "../../../assets/images/driver_transport_icon/moving.png";
import bicycleImg from "../../../assets/images/driver_transport_icon/bicycle.png";
import motorcycleImg from "../../../assets/images/driver_transport_icon/motorcycle.png";
import carImg from "../../../assets/images/driver_transport_icon/car.png";
import animalTransportImg from "../../../assets/images/driver_transport_icon/animal_transport.png";
import otherImg from "../../../assets/images/driver_transport_icon/other.png";
import fastImg from "../../../assets/images/driver_transport_icon/rocket.png";
import regularImg from "../../../assets/images/driver_transport_icon/pakete.png";
import ClientChatBox from "../../chat/ClientChatBox";
import {
  AlarmIcon,
  DeliverPointIcon,
  LeavePointIcon,
  PackageIcon,
  CalendarIcon,
  ArrowIcon,
} from "../../../assets/icons";

const DriverOffer = () => {
  const { t } = useTranslation();
  const [currentType, setCurrentType] = useState("furnitures");
  const [vehicles, setVehicles] = useState([]);
  const [selectedTransport, setSelectedTransport] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [offCanvasOpen, setOffCanvasOpen] = useState(null);
  const [showChatModal, setShowChatModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [activeKey, setActiveKey] = useState(null);
  const [unreadCounts, setUnreadCounts] = useState({});

  const [userType, setUserType] = useState(
    typeof window !== "undefined" ? localStorage.getItem("userType") : null,
  );

  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 0,
  });

  // SweetAlert configuration
  const showSweetAlert = (icon, title, text, confirmButtonText = "OK") => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText,
      customClass: {
        confirmButton: "btn btn-primary",
      },
    });
  };

  const showErrorAlert = (text) => {
    return showSweetAlert("error", t("driverOffer.alerts.error"), text);
  };

  const showSuccessAlert = (text) => {
    return showSweetAlert("success", t("driverOffer.alerts.success"), text);
  };

  const showWarningAlert = (text) => {
    return showSweetAlert("warning", t("driverOffer.alerts.warning"), text);
  };

  const fetchChatStatistics = async (item) => {
    try {
      let transportId;
      let orderId = item.id;

      if (currentType === "furnitures" || currentType === "cars") {
        transportId = item.transport?.id;
        if (!transportId) {
          transportId = item.transport?.transport_id;
        }
      } else {
        transportId = item.booking?.id;
        if (!transportId) {
          transportId = item.booking?.booking_id;
        }
      }

      console.log("📊 Fetching chat statistics:", { transportId, orderId });

      if (!transportId || !orderId) return 0;

      const result = await driverAPI.transportOrderChat.getMessages(
        transportId,
        orderId,
      );

      console.log("📊 Chat statistics response:", result);

      if (result.success) {
        const unreadCount = result.data?.data.statistics?.unread_count;
        console.log("📊 Unread count for order", unreadCount);
        return unreadCount;
      }
    } catch (error) {
      console.error("❌ Error fetching chat statistics:", error);
    }
    return 0;
  };

  const handleMessagesRead = (orderId) => {
    setUnreadCounts((prev) => ({
      ...prev,
      [orderId]: 0,
    }));
  };

  const handleOpenChat = async (item) => {
    if (!item) {
      showErrorAlert(t("driverOffer.alerts.noItemAvailable"));
      return;
    }

    if (!item.id) {
      showErrorAlert(t("driverOffer.alerts.orderIdMissing"));
      return;
    }

    let transportId;
    let orderId = item.id;

    if (currentType === "furnitures" || currentType === "cars") {
      transportId = item.transport?.id;
      if (!transportId) {
        transportId = item.transport?.transport_id;
      }
    } else {
      transportId = item.booking?.id;
      if (!transportId) {
        transportId = item.booking?.booking_id;
      }
    }

    if (!transportId) {
      showErrorAlert(t("driverOffer.alerts.transportInfoMissing"));
      return;
    }
    setSelectedTransport({
      transportId: transportId,
      orderId: orderId,
    });

    setShowChatModal(true);

    handleMessagesRead(orderId);
  };

  useEffect(() => {
    if (!loading && data.length > 0) {
      const fetchAllUnreadCounts = async () => {
        const counts = {};

        for (const item of data) {
          let transportId;
          const orderId = item.id;

          if (currentType === "furnitures" || currentType === "cars") {
            transportId = item.transport?.id || item.transport?.transport_id;
          } else {
            transportId = item.booking?.id || item.booking?.booking_id;
          }

          if (transportId && orderId) {
            const unreadCount = await fetchChatStatistics(item);
            counts[orderId] = unreadCount;
          }
        }

        setUnreadCounts(counts);
      };

      fetchAllUnreadCounts();
    }
  }, [data, loading, currentType]);

  const shouldShowChat = (type) => {
    return type === "furnitures" || type === "cars";
  };

  const handleFetch = async (page = 1) => {
    setLoading(true);
    try {
      const params = {
        page,
        per_page: pagination.per_page,
      };

      let response;

      if (currentType === "regular") {
        response = await driverAPI.bookingsOrders.pending(params);
      } else if (currentType === "cars") {
        response = await driverAPI.transportsOrders.carPending(params);
      } else if (currentType === "furnitures") {
        response = await driverAPI.transportsOrders.furniturePending(params);
      } else {
        throw new Error(`Invalid currentType: ${currentType}`);
      }

      console.log(
        "📡 Fetching data for type:",
        currentType,
        response.data?.data,
      );

      if (response && response.success) {
        const fetchedData = Array.isArray(response.data?.data)
          ? response.data.data
          : [];

        // تحقق من صحة البيانات لكل نوع
        const validatedData = fetchedData.map((item) => {
          if (currentType === "regular") {
            return {
              ...item,
              booking: item.booking || {}, // تأكد من وجود booking
            };
          } else {
            return {
              ...item,
              transport: item.transport || {}, // تأكد من وجود transport
            };
          }
        });

        setData(validatedData);

        setPagination(
          response.data?.meta || {
            current_page: page,
            last_page: 1,
            per_page: 10,
            total: validatedData.length || 0,
          },
        );

        console.log("Validated data:", validatedData);
      } else {
        console.error("API Error:", response?.message || "No response");
        setData([]);
        showErrorAlert(
          response?.message || t("driverOffer.alerts.fetchDataError"),
        );
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setData([]);
      showErrorAlert(t("driverOffer.alerts.fetchDataError"));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!["regular", "furnitures", "cars"].includes(currentType)) return;
    handleFetch(1);
  }, [currentType]);

  const handleDelete = async (item) => {
    if (!item?.id) {
      console.error("❌ No item ID provided for deletion");
      showErrorAlert(t("driverOffer.alerts.noItemId"));
      return;
    }

    setDeleteLoading(true);
    try {
      console.log("🗑️ Deleting item with ID:", item.id, "Type:", currentType);

      let response;

      if (currentType === "regular") {
        response = await driverAPI.bookingsOrders.delete(item.id);
      } else if (currentType === "cars") {
        response = await driverAPI.transportsOrders.deleteCar(item.id);
      } else if (currentType === "furnitures") {
        response = await driverAPI.transportsOrders.deleteFurniture(item.id);
      } else {
        throw new Error(`Invalid currentType for deletion: ${currentType}`);
      }

      if (response.success) {
        console.log("✅ Item deleted successfully");
        setData((prevData) => prevData.filter((i) => i.id !== item.id));
        setShowDeleteConfirm(false);
        setItemToDelete(null);

        handleFetch(pagination.current_page);

        showSuccessAlert(t("driverOffer.alerts.deleteSuccess"));
      } else {
        console.error("❌ Delete failed:", response.message);
        showErrorAlert(
          `${t("driverOffer.alerts.deleteFailed")}: ${t(response.message)}`,
        );
      }
    } catch (error) {
      console.error("❌ Error deleting item:", error);
      showErrorAlert(t("driverOffer.alerts.deleteError"));
    } finally {
      setDeleteLoading(false);
    }
  };

  const openDeleteConfirm = (item) => {
    setItemToDelete(item);
    setShowDeleteConfirm(true);
  };

  const parseCoordinates = (coordString) => {
    if (!coordString) return null;
    try {
      const [lat, lng] = coordString
        .split(",")
        .map((coord) => parseFloat(coord.trim()));
      return [lat, lng];
    } catch (error) {
      console.error("Error parsing coordinates:", error);
      return null;
    }
  };

  const transportImages = {
    palette: paletteImg,
    pakete: paketeImg,
    document: documentImg,
    furniture: furnitureImg,
    electrical: electricalImg,
    tires: tiresImg,
    refrigerator: refrigeratorImg,
    "building materials": buildingMaterialsImg,
    moving: movingImg,
    bicycle: bicycleImg,
    motorcycle: motorcycleImg,
    car: carImg,
    "animal transport": animalTransportImg,
    other: otherImg,
    fast: fastImg,
    regular: regularImg,
    furnitures: furnitureImg,
    cars: carImg,
  };

  const TransportImage = ({ type, item, className = "", size = 100 }) => {
    const getImageSrc = () => {
      // 1. Try shipment_data (for regular/fast orders)
      const shipmentData = item.booking?.shipment_data || item.shipment_data;
      if (shipmentData && shipmentData.length > 0) {
        const firstShipment = shipmentData[0].shipment_data?.toLowerCase();
        if (firstShipment) {
          // Normalization: German terms -> English keys
          let normalizedKey = firstShipment === "pallete" ? "palette" : firstShipment;
          normalizedKey = normalizedKey === "dokument" ? "document" : normalizedKey;
          normalizedKey = normalizedKey === "baustoffe" ? "building materials" : normalizedKey;
          normalizedKey = normalizedKey === "elektrisch" ? "electrical" : normalizedKey;

          if (transportImages[normalizedKey]) {
            return transportImages[normalizedKey];
          }
        }
      }

      // 2. Try transport_type
      if (item?.transport_type) {
        const key = item.transport_type.toLowerCase();
        if (transportImages[key]) return transportImages[key];
      }

      if (item.transport?.transport_type) {
        const key = item.transport.transport_type.toLowerCase();
        if (transportImages[key]) return transportImages[key];
      }

      // 3. Try item type
      if (item?.type) {
        const key = item.type.toLowerCase();
        if (transportImages[key]) return transportImages[key];
      }

      return transportImages[type] || transportImages.other;
    };

    const imageSrc = getImageSrc();

    return (
      <img
        src={imageSrc}
        alt={type}
        className={`transport-image ${className}`}
        style={{
          width: size ? `${size}px` : "100px",
          height: size ? `${size}px` : "100px",
          objectFit: "contain",
          // filter: "invert(1)"

        }}
        onError={(e) => {
          e.target.src = transportImages.other;
        }}
      />
    );
  };

  const getTypeIcon = (type, item) => {
    return (
      <TransportImage
        type={type}
        item={item}
        className="text-secondary mb-2"
        size={35}
      />
    );
  };

  const getTypeText = (type, item) => {
    if (
      (type === "regular" || type === "fast") &&
      item.booking?.shipment_data?.length > 0
    ) {
      return item.booking.shipment_data
        .map(
          (s) =>
            t(s.shipment_data) || s.shipment_data,
        )
        .join(", ");
    }
    switch (type) {
      case "fast":
        return `${t(item.type) || t("driverCard.general.item")} · ${item.quantity || 1
          }`;
      case "regular":
        return `${t(item.type) || t("driverCard.general.item")} · ${item.quantity || 1
          }`;
      case "furnitures":
        return (
          t(item.transport?.transport_type) || t("driverCard.general.transport")
        );
      case "cars":
        return (
          t(item.transport?.item_type) || t("driverCard.general.transport")
        );
      default:
        return t("driverCard.general.item");
    }
  };



  const getAddress = (type, item, isPickup = true) => {
    if (type === "furnitures" || type === "cars") {
      if (isPickup) {
        return (
          item.transport?.booking_from || t("driverOffer.general.notAvailable")
        );
      } else {
        return (
          item.transport?.booking_to || t("driverOffer.general.notAvailable")
        );
      }
    } else {
      if (isPickup) {
        return (
          item.booking?.booking_from?.[0] ||
          t("driverOffer.general.notAvailable")
        );
      } else {
        return (
          item.booking?.booking_to?.[0] || t("driverOffer.general.notAvailable")
        );
      }
    }
  };

  const getDateTime = (type, item, isPickup = true) => {
    if (type === "furnitures" || type === "cars") {
      // API returns dates already as DD.MM.YYYY — use directly, no formatDisplayDate
      const t_ = item.transport || {};
      if (isPickup) {
        const dateRaw = t_.loading_date_start || t_.loading_date || null;
        const dateEndRaw = t_.loading_date_end || null;
        return {
          date: dateRaw || t("driverOffer.general.notAvailable"),
          dateEnd: dateEndRaw || null,
          time:
            t_.loading_time_start ||
            t_.loading_time ||
            t("driverOffer.general.notAvailable"),
          timeEnd: t_.loading_time_end || null,
        };
      } else {
        const dateRaw = t_.unloading_date_start || t_.unloading_date || null;
        const dateEndRaw = t_.unloading_date_end || null;
        return {
          date: dateRaw || t("driverOffer.general.notAvailable"),
          dateEnd: dateEndRaw || null,
          time:
            t_.unloading_time_start ||
            t_.unloading_time ||
            t("driverOffer.general.notAvailable"),
          timeEnd: t_.unloading_time_end || null,
        };
      }
    } else {
      if (isPickup) {
        const loadingData = item.booking?.loading_date_time?.[0];
        if (loadingData) {
          const spaceIdx = loadingData.indexOf(" ");
          return {
            date:
              spaceIdx > -1 ? loadingData.substring(0, spaceIdx) : loadingData,
            time:
              spaceIdx > -1
                ? loadingData.substring(spaceIdx + 1).replace(" - ", " → ")
                : t("driverOffer.general.notAvailable"),
          };
        }
        return {
          date: t("driverOffer.general.notAvailable"),
          time: t("driverOffer.general.notAvailable"),
        };
      } else {
        const unloadingData = item.booking?.unloading_date_time?.[0];
        if (unloadingData) {
          const spaceIdx = unloadingData.indexOf(" ");
          return {
            date:
              spaceIdx > -1
                ? unloadingData.substring(0, spaceIdx)
                : unloadingData,
            time:
              spaceIdx > -1
                ? unloadingData.substring(spaceIdx + 1).replace(" - ", " → ")
                : t("driverOffer.general.notAvailable"),
          };
        }
        return {
          date: t("driverOffer.general.notAvailable"),
          time: t("driverOffer.general.notAvailable"),
        };
      }
    }
  };

  const getWeight = (type, item) => {
    if (type === "furnitures" || type === "cars") {
      return formatNumber(item.transport?.total_weight) + " kg";
    } else {
      return formatNumber(item.booking?.total_weight) + " kg";
    }
  };

  const getDistance = (type, item) => {
    let dist = "";
    if (type === "furnitures" || type === "cars") {
      dist = item.transport?.distance || t("driverOffer.general.notAvailable");
    } else {
      dist = item.booking?.distance || t("driverOffer.general.notAvailable");
    }
    return dist ? dist.replace("km", " km") : dist;
  };

  const getFromCoords = (type, item) => {
    const coords =
      type === "furnitures" || type === "cars"
        ? item.transport?.booking_from_lat_long
        : item.booking?.booking_from_lat_long;

    return parseCoordinates(coords);
  };

  const getToCoords = (type, item) => {
    const coords =
      type === "furnitures" || type === "cars"
        ? item.transport?.booking_to_lat_long
        : item.booking?.booking_to_lat_long;

    return parseCoordinates(coords);
  };

  // في DriverOffer.jsx - عدل دالة renderExpandedContent
  // في دالة renderExpandedContent في DriverOffer.jsx
  const renderExpandedContent = (item, index) => {
    const unreadCount = unreadCounts[item.id] || 0;

    if (currentType === "regular") {
      return (
        <BookingDetailsPage
          item={item.booking || {}}
          order={item}
          onClose={() =>
            setActiveKey((prev) => (prev === index.toString() ? null : prev))
          }
          onDelete={openDeleteConfirm}
          deleteLoading={deleteLoading}
          onChat={handleOpenChat}
          shouldShowChat={shouldShowChat(currentType)}
          currentType={currentType}
          // إخفاء أزرار receive و deliver
          showReceive={false}
          showDeliver={false}
          showDelete={true}
          showDriverDetails={true}
          showChat={false}
        />
      );
    } else {
      return (
        <TransportDetailsPage
          item={item.transport || {}}
          order={item}
          type={currentType}
          onClose={() =>
            setActiveKey((prev) => (prev === index.toString() ? null : prev))
          }
          onDelete={openDeleteConfirm}
          deleteLoading={deleteLoading}
          onChat={handleOpenChat}
          shouldShowChat={shouldShowChat(currentType)}
          // إخفاء أزرار receive و deliver
          showReceive={false}
          showDeliver={false}
          showDelete={true}
          showDriverDetails={true}
          showChat={true}
          showBoardNumber={false}
          unreadCount={unreadCount}
        />
      );
    }
  };

  const toggleOffCanvas = (index) => {
    setOffCanvasOpen(offCanvasOpen === index ? null : index);
  };
  const renderMobileCard = (item, index) => {
    const pickupDateTime = getDateTime(currentType, item, true);
    const deliveryDateTime = getDateTime(currentType, item, false);
    const pickupAddress = getAddress(currentType, item, true);
    const deliveryAddress = getAddress(currentType, item, false);
    const weight = getWeight(currentType, item);
    const distance = getDistance(currentType, item);
    const stopsCount = (currentType === "furnitures" || currentType === "cars")
      ? (Array.isArray(item.transport?.booking_from) ? item.transport.booking_from.length : 1)
      : (Array.isArray(item.booking?.booking_from) ? item.booking.booking_from.length : 1);

    return (
      <div key={index} className="dark-mobile-card">
        {/* Header: Artikel Title */}
        <div className="dark-mobile-card-header">
          <div className="dark-mobile-artikel-title">
            <TransportImage
              type={currentType}
              item={item}
              className="dark-mobile-transport-img"
              size={28}
            />
            <span>{getTypeText(currentType, item)}</span>
          </div>
          {unreadCounts[item.id] > 0 && (
            <Badge bg="danger">{unreadCounts[item.id]}</Badge>
          )}
          <div className="mb-1 d-flex align-items-center text-dark fw-bold justify-content-center">
            {item.status === 'rejected' && (
              <Badge bg="danger" className="fs-9">
                  {t(item.status)}
              </Badge>
            )}
          </div>
        </div>

        {/* Body */}
        <div className="dark-mobile-card-body">
          {/* Location Info */}
          <div className="dark-mobile-location-row">
            {/* From Location */}
            {/* <div className="dark-mobile-location-item">
            <div className="address">
              <FaMapMarkerAlt />
              <span>{pickupAddress}</span>
            </div>
            <div className="datetime">
              <span className="date-line">
                <FaCalendarAlt />
                {pickupDateTime.date}
              </span>
              <span className="time-line">
                <FaClock />
                {pickupDateTime.time}
              </span>
            </div>
          </div> */}

            {/* From Locations */}
            {Array.isArray(item.booking?.booking_from) &&
              item.booking?.booking_from.length > 0 ? (
              item.booking?.booking_from.map((location, i) => {
                const rawDt = item.booking?.loading_date_time?.[i] || "";
                const spaceIdx = rawDt.indexOf(" ");
                const dtDate =
                  spaceIdx > -1 ? rawDt.substring(0, spaceIdx) : rawDt || "-";
                const dtTime =
                  spaceIdx > -1
                    ? rawDt.substring(spaceIdx + 1).replace(" - ", " → ")
                    : "-";

                return (
                  <div
                    key={`pickup-${i}`}
                    className="dark-mobile-location-item"
                  >
                    <div className="address">
                      <FaMapMarkerAlt />
                      <span>{location}</span>
                    </div>

                    <div className="datetime">
                      <span className="date-line">
                        <FaCalendarAlt />
                        {dtDate}
                      </span>
                      <span className="date-line">
                        <AlarmIcon style={{ width: 14 }} />
                        {dtTime}
                      </span>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="dark-mobile-location-item">
                <div className="address">
                  <FaMapMarkerAlt />
                  <span>
                    {pickupAddress ?? t("driverCard.general.notAvailable")}
                  </span>
                </div>
                <div className="datetime">
                  <span className="date-line">
                    <FaCalendarAlt />
                    {pickupDateTime.date}
                    {pickupDateTime.time &&
                      pickupDateTime.time !==
                      t("driverOffer.general.notAvailable") &&
                      ` · ${pickupDateTime.time}`}
                    {pickupDateTime.dateEnd && (
                      <>
                        {" – "}
                        {pickupDateTime.dateEnd}
                        {pickupDateTime.timeEnd &&
                          ` · ${pickupDateTime.timeEnd}`}
                      </>
                    )}
                  </span>
                </div>
              </div>
            )}

            {/* To Locations */}
            {Array.isArray(item.booking?.booking_to) &&
              item.booking?.booking_to.length > 0 ? (
              item.booking?.booking_to.map((location, i) => {
                const rawDt = item.booking?.unloading_date_time?.[i] || "";
                const spaceIdx = rawDt.indexOf(" ");
                const dtDate =
                  spaceIdx > -1 ? rawDt.substring(0, spaceIdx) : rawDt || "-";
                const dtTime =
                  spaceIdx > -1
                    ? rawDt.substring(spaceIdx + 1).replace(" - ", " → ")
                    : "-";

                return (
                  <div
                    key={`delivery-${i}`}
                    className="dark-mobile-location-item"
                  >
                    <div className="address">
                      <FaMapMarkerAlt className="to-icon" />
                      <span>{location}</span>
                    </div>

                    <div className="datetime">
                      <span className="date-line">
                        <FaCalendarAlt />
                        {dtDate}
                      </span>
                      <span className="date-line">
                        <AlarmIcon style={{ width: 14 }} />
                        {dtTime}
                      </span>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="dark-mobile-location-item">
                <div className="address">
                  <FaMapMarkerAlt />
                  <span>
                    {deliveryAddress ?? t("driverCard.general.notAvailable")}
                  </span>
                </div>
                <div className="datetime">
                  <span className="date-line">
                    <FaCalendarAlt />
                    {deliveryDateTime?.date || "-"}
                    {deliveryDateTime?.time &&
                      deliveryDateTime.time !==
                      t("driverOffer.general.notAvailable") &&
                      ` · ${deliveryDateTime.time}`}
                    {deliveryDateTime?.dateEnd && (
                      <>
                        {" – "}
                        {deliveryDateTime.dateEnd}
                        {deliveryDateTime.timeEnd &&
                          ` · ${deliveryDateTime.timeEnd}`}
                      </>
                    )}
                  </span>
                </div>
              </div>
            )}
          </div>

          {/* Stats Row */}
          <div className="dark-mobile-stats-row">
            <div className="dark-mobile-stat-item">
              <span className="stat-label">Route:</span>
              <span className="stat-value">{distance}</span>
            </div>
            <div className="dark-mobile-stat-item">
              <span className="stat-label">Stops:</span>
              <span className="stat-value">{stopsCount}</span>
            </div>
            <div className="dark-mobile-stat-item">
              <span className="stat-label">Gewicht:</span>
              <span className="stat-value">{weight}</span>
            </div>
          </div>

          {/* Footer: Button */}
          <div className="dark-mobile-footer">
            <div className="dark-mobile-price">
              <span className="price-value">
                {item.discounted_price || item.price || "0"} EUR
              </span>
              <span className="price-label">(Netto)</span>
            </div>
            <button
              className="dark-mobile-details-btn"
              onClick={() => toggleOffCanvas(index)}
            >
              {t("driverCard.buttons.details")}
              <FaChevronDown />
            </button>
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      <NavbarMenu />
      <Container
        fluid
        className="p-4"
        style={{ minHeight: "100vh" }}
      >
        {/* 🔹 Tabs */}
        <Row className="text-center mb-0 mb-md-4">
          <Col>
            <div className="professional-tabs">
              <Button
                className={`tab-btn ${currentType === "regular" ? "bg-dark active" : "bg-orange"
                  }`}
                onClick={() => setCurrentType("regular")}
              >
                <FaBox className="me-2" />
                {t("driverOffer.orderTypes.regular")}
              </Button>
              <Button
                className={`tab-btn ${currentType === "furnitures" ? "bg-dark active" : "bg-orange"
                  }`}
                onClick={() => setCurrentType("furnitures")}
              >
                <FaCouch className="me-2" />
                {t("driverOffer.orderTypes.furniture")}
              </Button>
              <Button
                className={`tab-btn ${currentType === "cars" ? "bg-dark active" : "bg-orange"
                  }`}
                onClick={() => setCurrentType("cars")}
              >
                <FaCar className="me-2" />
                {t("driverOffer.orderTypes.car")}
              </Button>
            </div>
          </Col>
        </Row>

        {/* 🔹 Accordion للشاشات الكبيرة */}
        <Accordion
          activeKey={activeKey}
          onSelect={(key) => setActiveKey(key)}
          className="d-none d-md-block dark-accordion-container"
        >
          {loading && (
            <p className="text-center p-3 dark-info-label">
              {t("driverOffer.general.loading")}
            </p>
          )}
          {!loading && (!Array.isArray(data) || data.length === 0) && (
            <p className="text-center p-3 dark-info-label">
              {t("driverOffer.general.noData")}
            </p>
          )}


          {!loading &&
            Array.isArray(data) &&
            data.map((item, index) => {
              const pickupDateTime = getDateTime(currentType, item, true);
              const deliveryDateTime = getDateTime(currentType, item, false);
              const pickupAddress = getAddress(currentType, item, true);
              const deliveryAddress = getAddress(currentType, item, false);
              const weight = getWeight(currentType, item);
              const distance = getDistance(currentType, item);

              return (
                <Accordion.Item
                  eventKey={index.toString()}
                  key={item.id || index}
                >
                  <Accordion.Header>
                    <div className="w-100 p-2">
                      {/* Header Top: Vehicle */}
                      {/* <div
                        className="d-flex align-items-center mb-3 pb-3"
                        style={{ borderBottom: "1px solid rgb(212 212 212)" }}
                      >
                        <TransportImage
                          type={currentType}
                          item={item}
                          size={32}
                        />
                        <h6 className="mb-0 ms-3 text-dark fw-bold text-capitalize">
                          {getTypeText(currentType, item)}
                        </h6>
                        <div className="ms-auto d-flex align-items-center gap-2">
                          {unreadCounts[item.id] > 0 && (
                            <Badge bg="danger">{unreadCounts[item.id]}</Badge>
                          )}
                          <Badge
                            bg="secondary"
                            className="text-white px-3 py-1"
                            style={{ borderRadius: "20px", fontSize: "0.8rem", backgroundColor: "#333" }}
                          >
                            {(currentType === "furnitures" || currentType === "cars")
                              ? (Array.isArray(item.transport?.booking_from) ? item.transport.booking_from.length : 1)
                              : (Array.isArray(item.booking?.booking_from) ? item.booking.booking_from.length : 1)}{" "}
                            {t("driverCard.general.stopsCount", "Stops")}
                          </Badge>
                        </div>
                      </div> */}

                      {/* Middle Content */}
                      <Row className="align-items-center g-2 px-2 py-3">

                        {/* Transport Image */}
                        <Col xs={12} md={2} className="text-center">

                          <div className="mb-1 d-flex align-items-center text-dark fw-bold justify-content-center">
                            {item.status === 'rejected' && (
                              <Badge bg="danger" className="fs-6">
                                  {t(item.status)}
                              </Badge>
                            )}
                          </div>

                          <TransportImage
                            type={currentType}
                            item={item}
                            // size={50}
                            width={180}
                          />

                          <div className="mb-1 d-flex align-items-center text-dark fw-bold justify-content-center">
                            <span>{getTypeText(currentType, item)}</span>
                          </div>
                          
                        </Col>

                        {/* Pickup */}
                        <Col xs={12} md={2}>
                          <h6 className="text-orange fw-bold mb-2 small text-uppercase">
                            {t(
                              "driverCard.general.pickupTitle",
                              "ABHOLUNG (BELADUNG)",
                            )}
                          </h6>
                          {(Array.isArray(item.booking?.booking_from)
                            ? item.booking.booking_from
                            : [pickupAddress].filter(Boolean)
                          ).map((addr, i) => {
                            const rawDt =
                              item.booking?.loading_date_time?.[i] || "";
                            const spaceIdx = rawDt.indexOf(" ");
                            const dtDate =
                              spaceIdx > -1
                                ? rawDt.substring(0, spaceIdx)
                                : rawDt || pickupDateTime.date || "-";
                            const dtTime =
                              spaceIdx > -1
                                ? rawDt
                                  .substring(spaceIdx + 1)
                                  .replace(" - ", " → ")
                                : pickupDateTime.time
                                  ? pickupDateTime.time +
                                  (pickupDateTime.timeEnd
                                    ? ` → ${pickupDateTime.timeEnd}`
                                    : "")
                                  : "-";
                            return (
                              <div key={i} className="mb-2">
                                <div className="fw-bold text-orange mb-1 small">
                                  {t("driverCard.general.pickup")} ({i + 1})
                                </div>
                                <div className="mb-1 d-flex align-items-center text-dark fw-bold">
                                  <FaMapMarkerAlt className="text-orange me-2 fs-5 flex-shrink-0" />
                                  <span>{addr}</span>
                                </div>
                                <div
                                  className="p-2 d-inline-block"
                                  style={{
                                    backgroundColor: "inherit",
                                    borderRadius: "8px",
                                    border: "1px solid rgb(212 212 212 / 39%)",
                                  }}
                                >
                                  <div className="d-flex align-items-center mb-1 gap-3">
                                    <span
                                      className="d-flex align-items-center dark-info-label small"
                                      style={{ minWidth: "70px" }}
                                    >
                                      <FaCalendarAlt className="text-orange me-2" />{" "}
                                      {t("driverCard.general.dates", "Datum")}
                                    </span>
                                    <span className="text-dark fw-medium small flex-grow-1 text-start">
                                      {dtDate}
                                    </span>
                                  </div>
                                  <div
                                    className="d-flex align-items-center mt-1 pt-1 gap-3"
                                    style={{ borderTop: "1px solid rgb(212 212 212)" }}
                                  >
                                    <span
                                      className="d-flex align-items-center dark-info-label small"
                                      style={{ minWidth: "70px" }}
                                    >
                                      <AlarmIcon
                                        className="text-orange me-2"
                                        style={{ width: 16 }}
                                      />{" "}

                                      <span className="dark-info-label" style={{ marginLeft: "4px" }}>
                                        {t("driverCard.general.time", "Uhrzeit")}
                                      </span>

                                    </span>
                                    <span className="text-dark fw-medium small flex-grow-1 text-start d-flex align-items-center">
                                      {dtTime}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </Col>

                        {/* Arrow */}
                        <Col
                          xs={12}
                          md={1}
                          className="text-start d-none d-md-flex p-0"
                          style={{ position: "relative", minHeight: "100px" }}
                        >
                          <div
                            className="d-flex align-items-center justify-content-start"
                            style={{
                              position: "absolute",
                              top: "70%",
                              left: "0%",
                              transform: "translate(0%, -50%)",
                              minWidth: "80px",
                              width: "60%",
                              zIndex: 1,
                            }}
                          >
                            <div
                              style={{
                                height: "1px",
                                backgroundColor: "#6c757d",
                                flex: 1,
                              }}
                            ></div>
                            <div
                              style={{
                                width: "0",
                                height: "0",
                                borderTop: "4px solid transparent",
                                borderBottom: "4px solid transparent",
                                borderLeft: "6px solid #6c757d",
                              }}
                            ></div>
                          </div>
                        </Col>

                        {/* Delivery */}
                        <Col xs={12} md={2}>
                          <h6 className="text-orange fw-bold mb-2 small text-uppercase">
                            {t(
                              "driverCard.general.deliveryTitle",
                              "ZUSTELLUNG (ENTLADUNG)",
                            )}
                          </h6>
                          {(Array.isArray(item.booking?.booking_to)
                            ? item.booking.booking_to
                            : [deliveryAddress].filter(Boolean)
                          ).map((addr, i) => {
                            const rawDt =
                              item.booking?.unloading_date_time?.[i] || "";
                            const spaceIdx = rawDt.indexOf(" ");
                            const dtDate =
                              spaceIdx > -1
                                ? rawDt.substring(0, spaceIdx)
                                : rawDt || deliveryDateTime.date || "-";
                            const dtTime =
                              spaceIdx > -1
                                ? rawDt
                                  .substring(spaceIdx + 1)
                                  .replace(" - ", " → ")
                                : deliveryDateTime.time
                                  ? deliveryDateTime.time +
                                  (deliveryDateTime.timeEnd
                                    ? ` → ${deliveryDateTime.timeEnd}`
                                    : "")
                                  : "-";
                            return (
                              <div key={i} className="mb-2">
                                <div className="fw-bold text-orange mb-1 small">
                                  {t("driverCard.general.delivery")} ({i + 1})
                                </div>
                                <div className="mb-1 d-flex align-items-center text-dark fw-bold">
                                  <FaMapMarkerAlt className="text-secondary me-2 fs-5 flex-shrink-0" />
                                  <span>{addr}</span>
                                </div>
                                <div
                                  className="p-2 d-inline-block"
                                  style={{
                                    backgroundColor: "inherit",
                                    borderRadius: "8px",
                                    border: "1px solid rgb(212 212 212 / 39%)",
                                  }}
                                >
                                  <div className="d-flex align-items-center mb-1 gap-3">
                                    <span
                                      className="d-flex align-items-center dark-info-label small"
                                      style={{ minWidth: "70px" }}
                                    >
                                      <FaCalendarAlt className="text-orange me-2" />{" "}
                                      {t("driverCard.general.dates", "Datum")}
                                    </span>
                                    <span className="text-dark fw-medium small flex-grow-1 text-start">
                                      {dtDate}
                                    </span>
                                  </div>
                                  <div
                                    className="d-flex align-items-center mt-1 pt-1 gap-3"
                                    style={{ borderTop: "1px solid rgb(212 212 212)" }}
                                  >
                                    <span
                                      className="d-flex align-items-center dark-info-label small"
                                      style={{ minWidth: "70px" }}
                                    >
                                      <AlarmIcon
                                        className="text-orange me-2"
                                        style={{ width: 16 }}
                                      />{" "}
                                      <span className="dark-info-label" style={{ marginLeft: "4px" }}>
                                        {t("driverCard.general.time", "Uhrzeit")}
                                      </span>
                                    </span>
                                    <span className="text-dark fw-medium small flex-grow-1 text-start d-flex align-items-center">
                                      {dtTime}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </Col>

                        {/* Stats */}
                        <Col xs={12} md={2} className="text-center">
                          <div
                            className="ps-md-2"
                            style={{ borderLeft: "1px solid rgb(212 212 212)" }}
                          >
                            <div
                              className="mb-2 pb-2"
                              style={{ borderBottom: "1px solid rgb(212 212 212)" }}
                            >
                              <div className="dark-info-label d-flex align-items-center justify-content-center mb-1">
                                <FaRoute className="me-2 text-secondary" />{" "}
                                {t("driverCard.general.route", "Route")}
                              </div>
                              <div className="text-dark fw-bold fs-5">
                                {distance || "N/A"}
                              </div>
                            </div>
                            <div>
                              <div className="dark-info-label d-flex align-items-center justify-content-center mb-1">
                                <FaWeightHanging className="me-2 text-secondary" />{" "}
                                {t("driverCard.general.totalWeight", "Gewicht:")}
                              </div>
                              <div className="text-dark fw-bold fs-5">
                                {weight}
                              </div>
                            </div>
                          </div>
                        </Col>

                        {/* price */}
                        <Col xs={12} md={2} className="text-center">
                          <span className="card-price text-success">{item.price ? `${item.price} €` : ""}</span>

                          <div className="mb-1 d-flex align-items-center text-dark fw-bold justify-content-center">
                            <div
                              className={`${activeKey === index.toString() ? "open" : ""} py-2`}
                            >
                              <button className="btn-orange">{t("driverCard.general.showDetails")} →</button>
                            </div>
                          </div>
                          
                        </Col>
                      </Row>

                      {/* <div
                        className="d-flex justify-content-end mt-3 pt-2 pe-3"
                        // style={{ borderTop: "1px solid #333" }}
                      >
                        <div
                          className={`dark-artikel-collapse-icon ${activeKey === index.toString() ? "open" : ""}`}
                        >
                          <FaChevronDown style={{ color: "#ff7b00" }} />
                        </div>
                      </div> */}
                    </div>
                  </Accordion.Header>

                  <Accordion.Body>
                    <div
                      // className="dark-bg-darker"
                      style={{ borderRadius: "12px", padding: "1rem" }}
                    >
                      <Row>{renderExpandedContent(item, index)}</Row>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              );
            })}
        </Accordion>
        {/* 🔹 Mobile View */}
        <div className="d-block d-md-none ">
          {loading && (
            <div className="text-center">
              <Spinner animation="border" variant="primary" />
              <p className="mt-2">{t("driverCard.general.loading")}</p>
            </div>
          )}

          {!loading && (!Array.isArray(data) || data.length === 0) && (
            <p className="text-center">{t("driverCard.general.noData")}</p>
          )}

          {!loading &&
            Array.isArray(data) &&
            data.map((item, index) => renderMobileCard(item, index))}
        </div>

        {/* Modal تأكيد الحذف */}
        <Modal
          show={showDeleteConfirm}
          onHide={() => {
            setShowDeleteConfirm(false);
            setItemToDelete(null);
          }}
          centered
        >
          <Modal.Body className="text-center p-4">
            <h5 className="fw-bold mb-3">
              {t("driverOffer.modals.deleteConfirm")}
            </h5>
            <p className="text-muted">
              {t("driverOffer.modals.deleteWarning")}
            </p>
            <div className="d-flex justify-content-center gap-3 mt-4">
              <Button
                variant="secondary"
                onClick={() => {
                  setShowDeleteConfirm(false);
                  setItemToDelete(null);
                }}
                disabled={deleteLoading}
              >
                {t("driverOffer.buttons.cancel")}
              </Button>
              <Button
                variant="danger"
                onClick={() => handleDelete(itemToDelete)}
                disabled={deleteLoading}
              >
                {deleteLoading
                  ? t("driverOffer.buttons.deleting")
                  : t("driverOffer.buttons.delete")}
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        {/* 🔹 Off Canvas Component */}
        {!loading &&
          Array.isArray(data) &&
          data.map((item, index) => {
            return (
              <div key={index}>
                {/* Overlay */}
                <div
                  className={`offcanvas-overlay ${offCanvasOpen === index ? "show" : ""
                    }`}
                  onClick={() => setOffCanvasOpen(null)}
                />

                {/* Off Canvas Body */}
                <div
                  className={`offcanvas-accordion-body ${offCanvasOpen === index ? "open" : ""
                    }`}
                >
                  <button
                    className="offcanvas-close-btn"
                    onClick={() => setOffCanvasOpen(null)}
                  >
                    <FaTimes />
                  </button>

                  <div className="offcanvas-content">
                    {renderExpandedContent(item, index)}
                  </div>
                </div>
              </div>
            );
          })}

        <DriverChatModal
          show={showChatModal}
          handleClose={() => setShowChatModal(false)}
          transportId={selectedTransport?.transportId}
          orderId={selectedTransport?.orderId}
        />

        {pagination.total > 0 && (
          <PaginationComponent
            currentPage={pagination.current_page}
            lastPage={pagination.last_page}
            onPageChange={handleFetch}
            disabled={loading}
          />
        )}
      </Container>

      {(userType === "client" || userType === "driver") && (
        <ClientChatBox userType={userType} />
      )}
    </>
  );
};

export default DriverOffer;
